import React from "react";
import { ActiveFilters } from "web/react/components/filter-redesign/active-filters/active-filters";
import { AdvancedFilters } from "web/react/components/filter-redesign/advanced-filters";
import { FilterDialogScreen } from "web/react/components/filter-redesign/filter-dialog";
import { FilterSection } from "web/react/components/filter-redesign/filter-section";
import { PriceFilters } from "web/react/components/filter-redesign/price-filters";
import { QuickFilters } from "web/react/components/filter-redesign/quick-filters";
import { SortBy } from "web/react/components/filter-redesign/sort-by";
import { useActiveFilters } from "web/react/hooks/filters";
import { useAvailableFilters } from "web/react/hooks/filters/use-available-filters";

export function FiltersInitialScreen(): JSX.Element {
    const { count } = useActiveFilters();
    const availableFilters = useAvailableFilters();

    return (
        <FilterDialogScreen showBackButton={false} title="Filter">
            <SortBy />
            {count ? <ActiveFilters /> : null}
            {availableFilters.includes("quick_filters") ? <QuickFilters /> : null}
            {availableFilters.includes("final_price") ? <PriceFilters /> : null}
            <FilterSection title="Advanced filters" divider={false}>
                <AdvancedFilters />
            </FilterSection>
        </FilterDialogScreen>
    );
}
